<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="college-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex align-items-center gap-10">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Collèges électoraux et répartition</p>
            <p class="no-margin dark-gray text-sm">Configuration de chaque collège électoral</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>

    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>

  <div *ngIf="isExpanded" class="p-20 flex flex-column gap-30">
    <div *ngFor="let college of colleges; let i = index" class="p-10 bg-light-gray" style="border: solid 1px #F0F5FF;">
      <p class="light-blue bold">College {{i + 1}}</p>
      <!-- <app-union [(college)]="unions[i]" [index]="i"></app-union> -->
      <app-one-college-verification [(college)]="colleges[i]"></app-one-college-verification>
    </div>
  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>

  </div>
</div>